import ApiHelper from "~/helpers/api-helper";

export default class TagService {

	public static list($axios, pagination, filters = {}) {
		const params = ApiHelper.setQueryParams(pagination, filters);
		return $axios.$get('/public-tag', { params: params });
	}

	public static getSelectorList($axios) {
		return $axios.$get(`/public-tag/filter`);
	}

}
